import { Component } from '@angular/core';
import { JobsService } from 'core/services';
@Component({
  selector: 'lms-job-notifications',
  templateUrl: './job-notifications.component.html',
  styleUrls: ['./job-notifications.component.scss']
})
export class JobNotificationsComponent {
  jobs: Map<string, any>;

  constructor(public jobsService: JobsService) {
    this.jobsService.getJobs$().subscribe((jobs) => {
      this.jobs = jobs;
    });
  }

  public downloadCSV({ errors, type }): void {
    this.jobsService.downloadCSV(errors, type);
  }

  /**
   * Navigate to the url from the job
   * @param url
   * @param type
   */
  public navUrlLink({ url, type }): void {
    this.jobsService.navUrlLink(url, type);
  }
}
